import Link from "next/link";
import HotelPlaceholder from "../../public/svg/hotel-placeholder";
import { isDateExpired } from "../../utils/common";
import Cta from "./cta";
import { tailwindClasses } from "./tailwindClasses";

const HotelListing = ({ hotelList, placeName }) => {
  const {
    heading,
    headingWrap,
    // hotelWrap,
    imgClass,
    imgWrap,
    mainWrap,
    subHotelWrap,
    titleWrap,
    // linkCls,
    // buttons
  } = tailwindClasses;

  return (
    <>
      {Array.isArray(hotelList) &&
      hotelList?.filter((hotel) => !isDateExpired(hotel?.expiry_on)).length >
        0 ? (
        <div className={mainWrap}>
          <h2 className={headingWrap}>
            Discover your perfect stay: Hotels just for you, with direct deals
          </h2>
          <div
            className={
              "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-4"
            }
          >
            {hotelList.map((hotel, i) => (
              <div key={i} className={"hotelWrap overflow-hidden"}>
                {!isDateExpired(hotel?.expiry_on) && (
                  <div
                    className={`border border-1 border-[#d1d5db] overflow-hidden ${subHotelWrap}`}
                    // onClick={() => redirectPage(hotel?.link)}
                  >
                    <div className={imgWrap}>
                      {hotel?.card_bg ? (
                        <img
                          src={hotel?.card_bg}
                          alt={hotel?.alt}
                          className={imgClass}
                        />
                      ) : (
                        <HotelPlaceholder className="mx-auto mt-[8px]" />
                      )}
                    </div>
                    <div className={titleWrap}>
                      <div className="p-2">
                        <h2 className={heading}>{hotel?.hotel}</h2>
                        {/* <p className="font-semibold">{hotel?.heading}</p> */}
                        <p className="text-sm">{hotel?.location}</p>
                      </div>
                      <Cta mobile={hotel?.mobile} link={hotel?.link} />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="main-wrapper !mb-[38px] lg:!mb-[48px] pl-[8px] info border-l-4 border-[#54AF4B] lg:text-[24px] med-italic">
          No hotels are currently listed with us in this page of {placeName}. Be
          the first to join us by listing your hotel today!.
          <Link href="/contact">
            <div>
              <u>Click here to contact us</u>
            </div>
          </Link>
        </div>
      )}
    </>
  );
};

export default HotelListing;
